import React, { useMemo } from 'react';
import WorldMap from './WorldMap';
import CountryMap from './CountryMap';
import { resolveCountryCodeFromLocation } from '../../utils/countryCodeUtils';

export default function ScaleSilhouette({ scale, location, className = '' }) {
  const code = useMemo(() => resolveCountryCodeFromLocation(location), [location]);

  if (scale === 'global') {
    return <WorldMap className={className} />;
  }

  if (code) {
    return <CountryMap countryCode={code} className={className} />;
  }

  return null;
}
